import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, ArrowRight, Zap, AlertTriangle, Tag, Flame } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#EEF2FF] pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-201">
      <div className="absolute top-0 right-0 -z-10 w-1/2 h-full bg-gradient-to-bl from-[#E0E7FF]/40 to-transparent rounded-bl-[100px] hidden lg:block" data-id="element-202" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-204">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-205">
            <div className="flex flex-wrap gap-2 mb-6" data-id="element-206">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-[#4338CA]/10 text-[#4338CA]" data-id="element-207">
                <CheckCircle2 className="w-3 h-3" data-id="element-208" /> No Medication
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-[#4338CA]/10 text-[#4338CA]" data-id="element-209">
                <CheckCircle2 className="w-3 h-3" data-id="element-210" /> No Overwhelm
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-[#FDE68A]/60 text-[#92400E] font-bold" data-id="element-211">
                <Flame className="w-3 h-3" data-id="element-212" /> Start Today
              </span>
            </div>

            <h1 className="text-4xl lg:text-6xl font-bold text-[#1E1B4B] leading-tight mb-4" data-id="element-213">
              Reduce Anxiety in{' '}
              <span className="text-[#4338CA] relative" data-id="element-214">
                <span className="relative z-10" data-id="element-215">7 Days</span>
                <span className="absolute bottom-1 left-0 w-full h-3 bg-[#FDE68A]/60 -z-0 rounded-sm" data-id="element-216"></span>
              </span>
            </h1>
            <p className="text-xl text-[#44403C] mb-6 font-medium" data-id="element-217">
              <span className="font-bold text-[#1E1B4B]" data-id="element-218">
                Without Medication.
              </span>{' '}
              Without Overwhelm. Without "Positive Thinking."
            </p>

            <p className="text-lg text-[#78716C] mb-4 leading-relaxed" data-id="element-219">
              Meet the{' '}
              <strong className="text-[#1E1B4B]" data-id="element-220">7 Signals Reset™</strong> — a
              simple, structured nervous system plan that{' '}
              <span className="bg-[#FDE68A]/50 px-1 rounded font-semibold text-[#1E1B4B]" data-id="element-221">
                lowers your anxiety baseline
              </span>{' '}
              in one week. No theory. One action per day.{' '}
              <span className="text-[#4338CA] font-semibold" data-id="element-222">
                Regulation you can feel.
              </span>
            </p>

            <p className="text-sm text-rose-600 font-semibold mb-8 bg-rose-50 px-4 py-2 rounded-lg border border-rose-100 inline-flex items-center gap-2" data-id="element-223">
              <AlertTriangle className="w-4 h-4 flex-shrink-0" data-id="element-224" />
              Every day without a plan, your nervous system stays stuck in
              "threat mode."
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-225">
              <Button size="lg" icon={ArrowRight} href="#the-plan" data-id="element-226">
                See The 7-Day Plan
              </Button>
              <span className="flex items-center gap-1.5 text-sm text-[#78716C]" data-id="element-227">
                <Zap className="w-4 h-4 text-[#4338CA]" data-id="element-228" /> Instant access ·
                Start in 2 minutes
              </span>
            </div>

            <div className="mb-10 bg-[#FDE68A]/30 border border-[#FDE68A] rounded-lg px-4 py-3 inline-flex items-center gap-2" data-id="element-229">
              <Tag className="w-4 h-4 text-[#92400E]" data-id="element-230" />
              <span className="text-sm font-bold text-[#92400E]" data-id="element-231">
                Launch Price: $9.97
              </span>
              <span className="text-xs text-[#78716C]" data-id="element-232">(value: $126.88)</span>
            </div>

            <div className="flex items-center gap-3 mb-10 bg-white/80 backdrop-blur-sm px-4 py-3 rounded-full shadow-sm border border-[#E0E7FF] w-fit" data-id="element-233">
              <div className="flex -space-x-2" data-id="element-234">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=40&h=40&fit=crop&crop=face" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-235" />
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-236" />
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-237" />
              </div>
              <div className="flex flex-col" data-id="element-238">
                <div className="flex items-center" data-id="element-239">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#818CF8] fill-current" data-id="element-240" />)}
                </div>
                <span className="text-sm font-medium text-[#44403C]" data-id="element-241">
                  "I noticed it on Day 3..."
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 text-sm text-[#44403C]" data-id="element-242">
              {['One action per day', 'Nervous system focus', 'Zero fluff'].map((item, i) => <div key={i} className="flex items-center bg-white px-4 py-2 rounded-lg shadow-sm border border-[#E0E7FF]" data-id="element-243">
                    <CheckCircle2 className="w-4 h-4 text-[#4338CA] mr-2" data-id="element-244" />
                    {item}
                  </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-245">
            <div className="relative z-10 bg-white rounded-3xl shadow-xl p-6 md:p-8 max-w-md mx-auto transform rotate-1 hover:rotate-0 transition-transform duration-300 border border-[#E0E7FF]" data-id="element-246">
              <div className="absolute -top-4 -right-4 bg-[#818CF8] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg z-20" data-id="element-247">
                7 Signals Reset™
              </div>

              <div className="aspect-[4/5] rounded-2xl overflow-hidden mb-6 bg-[#EEF2FF] relative group flex items-center justify-center" data-id="element-248">
                <img src="https://cdn.magicpatterns.com/uploads/k5HrkBhYo8FUUgAK4MLAGa/ChatGPT_Image_Feb_15,_2026,_10_55_06_PM.png" alt="7 Signals Reset™ - How to Reduce Anxiety in 7 Days Without Medication" loading="lazy" decoding="async" className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500" data-id="element-249" />
              </div>

              <div className="flex items-center justify-between mb-4" data-id="element-250">
                <div className="flex items-center space-x-1" data-id="element-251">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-[#818CF8] fill-current" data-id="element-252" />)}
                  <span className="ml-2 text-sm font-bold text-[#1E1B4B]" data-id="element-253">
                    4.9
                  </span>
                </div>
                <span className="text-sm text-[#78716C]" data-id="element-254">Instant Access</span>
              </div>

              <Button fullWidth variant="primary" onClick={() => window.open('https://bullygooddogs.com/cart/add?id=51339283890493&quantity=1', '_blank')} data-id="element-255">
                Start My Reset
              </Button>
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#4338CA]/10 rounded-full blur-3xl -z-10" data-id="element-256" />
          </motion.div>
        </div>
      </div>
    </section>;
}